import { useContext } from "react";
import { ColorProvider } from "~components/common/Layout";

export const Natural = () => {
  const { color, productBackground } = useContext(ColorProvider);
  return (
    <svg
      width="61"
      height="60"
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.666992"
        y="0.5"
        width="59"
        height="59"
        rx="29.5"
        fill="white"
      />
      <rect
        x="0.666992"
        y="0.5"
        width="59"
        height="59"
        rx="29.5"
        stroke="#E2DFDF"
      />
      <circle
        cx="41.4385"
        cy="30"
        r="5.77148"
        fill={productBackground || color}
      />
      <path
        d="M19.168 15C25.2391 15 30.168 19.9289 30.168 26C24.0969 26 19.168 21.0711 19.168 15Z"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M41.167 15C35.0959 15 30.167 19.9289 30.167 26C36.2381 26 41.167 21.0711 41.167 15Z"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.167 45H45.1671"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.167 30H45.1671"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="29.6768"
        y="33.9924"
        width="4.73592"
        height="7.00013"
        rx="2.36796"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="21.8359"
        y="33.9924"
        width="4.73592"
        height="7.00013"
        rx="2.36796"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.7294 40.9926V33.9924L16.4678 36.4123"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M37.9606 40.9924L42.4401 33.9924"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="38.188" cy="34.2946" r="1.16745" fill="black" />
      <circle cx="41.9077" cy="40.7029" r="1.16745" fill="black" />
    </svg>
  );
};
